import { useEffect, useState } from 'react';
import { BellRing } from 'lucide-react';
import { traducirErrorBackend } from '@renderer/lib/mensajesError';

/**
 * Sprint 163 — El interruptor del aviso "va en camino". Sólo el dueño lo ve (sección `avisos`).
 *
 * Apagado por defecto. El texto dice la condición para que sirva: marcar "salió" en el momento en que
 * sale la moto. Si se marca cuando la comida ya llegó, el aviso llega tarde y es peor que no avisar.
 */
export function AvisoEnCaminoForm() {
  const [activo, setActivo] = useState<boolean | null>(null);
  const [funciona, setFunciona] = useState(true);
  const [guardando, setGuardando] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    void window.api.avisos.estado().then((r) => {
      if (r.ok) {
        setActivo(r.data.activo);
        setFunciona(r.data.funciona);
      }
    });
  }, []);

  if (activo === null) return null;

  const cambiar = async (nuevo: boolean) => {
    setGuardando(true);
    setError(null);
    const r = await window.api.avisos.configurar({ activo: nuevo });
    setGuardando(false);
    if (r.ok) {
      setActivo(r.data.activo);
      setFunciona(r.data.funciona);
    } else setError(traducirErrorBackend(r.error, r.codigo));
  };

  return (
    <div className="card max-w-2xl space-y-3">
      <div className="flex items-center gap-2">
        <BellRing className="h-5 w-5 text-primary" aria-hidden />
        <h3 className="text-lg font-bold">Avisarle al cliente cuando su pedido va en camino</h3>
      </div>
      <p className="text-base text-slate-700">
        En la página de su pedido, el cliente puede tocar <strong>“Avísame cuando mi pedido salga”</strong>. Cuando
        marques que el pedido salió, <strong>su celular vibra y suena</strong>, como en las apps de comida.
      </p>
      <p className="rounded-lg bg-amber-50 px-3 py-2 text-sm text-amber-900">
        Para que sirva, marca que salió <strong>en el momento en que se va la moto</strong>. Si lo marcas cuando la
        comida ya llegó, el aviso le llega tarde.
      </p>
      <label className="flex min-h-[48px] cursor-pointer items-center gap-3">
        <input
          type="checkbox"
          className="h-6 w-6"
          checked={activo}
          disabled={guardando}
          onChange={(e) => void cambiar(e.target.checked)}
        />
        <span className="text-base font-semibold text-slate-900">{activo ? 'Encendido' : 'Apagado'}</span>
      </label>
      {activo && !funciona && (
        <p className="rounded-lg bg-red-50 px-3 py-2 text-sm text-red-800" role="alert">
          Está encendido, pero ahora mismo <strong>no puede avisar</strong>: los clientes no verán el botón. Pídele a
          soporte que lo revise.
        </p>
      )}
      {error && (
        <p className="rounded-lg bg-red-50 px-3 py-2 text-sm text-red-800" role="alert">
          {error}
        </p>
      )}
    </div>
  );
}
